export default "__VITE_PUBLIC_ASSET__499cde06__"